/// <reference types="webpack-env" />
const context = require.context("../../../", true, /\.png$/);
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const allPngs: Record<string, string> = Object.fromEntries(context.keys().map((key: string) => [key, context(key) as string]));
